// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","342":"ea88be26","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"9dafc6872345f592bd7d","342":"42358b1d6a82833ccc00","452":"6007f9b121a8bcfe521e","453":"11d3d5fe2bf8ee72a6ed","454":"63a45c4a2096d1badf47","551":"645cc80334c14bd1b8b8"}[chunkId] + ".js";
};